import React, { useState, ForwardedRef, useImperativeHandle, useRef, useEffect } from 'react';
import Chart from '..';
import { ChartRef, IWordCloudChartProps } from '../_config/_interface';
import { useWordCloudOptions } from '../chartConfigs/wordCloudChartHooks';


const WordCloudChartInner: React.ForwardRefRenderFunction<ChartRef, IWordCloudChartProps> = (props, ref: ForwardedRef<ChartRef>) => {
  const [option, setOption] = useState<any>(null);
  const chartRef = useRef<ChartRef>(null);
  // 获取实例
  const instance = () => chartRef?.current?.instance();
  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance
  }));

  const options = useWordCloudOptions(props);

  // TODO 解决hover字体加粗错位,option由hooks生成一直为新对象触发更新，优化缓存
  useEffect(() => {
    setOption(options);
  }, [JSON.stringify(options)]);

  return <div className="analysis-chart-container dbl-word-cloud-chart">
    <div className='analysis-chart-content'>
      {/** 词云图notMerge推荐false动态数据更新，设置为true会重新渲染出现词云重复的问题 */}
      <Chart ref={chartRef} option={option} notMerge={false} />
    </div>
    {
      option?.legend?.show && option?.legend?.data?.length > 0 && <div className="dbl-word-cloud-chart-legend">
        {option?.legend?.data?.map(({ name, color }, index) => (
          <div className="dbl-word-cloud-chart-legend-item" key={index}>
            <div
              className="dbl-word-cloud-chart-legend-icon"
              style={{ backgroundColor: color }}
            />
            <div className="dbl-word-cloud-chart-legend-name">{name}</div>
          </div>
        ))}
      </div>
    }
  </div>;
};

const WordCloudChart = React.forwardRef(WordCloudChartInner);

export default WordCloudChart;